import cookie from 'react-cookies'
import { isWindowInIframe } from './nav'
// Note: These functions are isolated to assist with imports, generally you shouldn't be calling these, use the functions on trolley/trolleyList instead

export const setActiveTrolleyCookieId = (trolley_id) => {
  clearActiveTrolleyCookieId()
  if (isWindowInIframe) {
    document.cookie = `trolley_id=${trolley_id};path=/;SameSite=None; Secure;`
  }else {
    cookie.save('trolley_id', trolley_id, { path: '/' })
  }
}

export const clearActiveTrolleyCookieId = () => {
    cookie.remove('trolley_id', { path: '/' })
}

export const getActiveTrolleyCookieId = () => {
    return cookie.load('trolley_id', { path: '/' })
}
